<template>
    <div class="container">
        <div class="main-container">
            <div class="left-section">
                <div class="top-container">
                    <div class="nav-wrapper">
                        <div class="logo-wrapper">
                            <img :src="require('@/assets/icons/murugesh-logo.svg')" alt="">
                        </div>
                        <p class="name"> <span class="first">M</span>urugesh <span class="first">R</span>aja <span
                                class="dot">.</span> </p>
                    </div>
                </div>
                <div class="name-info-section">
                    <p class="hello-text">
                        Hello There.
                    </p>
                    <div class="name-info-wrapper">
                        <p class="name-text">This is <span class="no-break-text">
                                Murugesh Raja<span class="dot">.</span>
                            </span></p>
                        <p class="designation-text">-Full Stack Developer</p>
                    </div>
                </div>
            </div>
            <div class="center-section">
                <div class="center-background" v-motion :initial="{
                    opacity: 0,
                    y: -100,
                }" :enter="{
                    opacity: 1,
                    y: 0,
                }">

                </div>
                <div class="skill-card left" v-motion :initial="{
                    opacity: 0,
                    x: -10,
                }" :enter="{
                    opacity: 1,
                    x: 0,
                }">
                    <img :src="require('@/assets/icons/react.svg')" alt="">
                </div>
                <div class="skill-card right" v-motion :initial="{
                    opacity: 0,
                    x: 10,
                }" :enter="{
                    opacity: 1,
                    x: 0,
                }">
                    <img :src="require('@/assets/icons/angular.png')" alt="">
                </div>
                <div class="image-wrapper" v-motion :initial="{
                    opacity: 0,
                    y: 500,
                }" :enter="{
                    opacity: 1,
                    y: 0,
                }">
                    <img :src="require('@/assets/images/Murugesh-Portfolio-Profile-2026.png')" alt="">
                </div>
            </div>
            <div class="right-section">
                <div class="left-cont">
                    <div class="title-section" v-motion :initial="{
                        opacity: 0,
                        y: 100,
                    }" :enter="{
                        opacity: 1,
                        y: 0,
                    }">
                        <!-- <p class="title">Behind the Code: My Story</p> -->
                        <div class="wrapper">
                            <div class="typing-demo title">{{ typedTitle }}<span class="cursor"></span></div>
                        </div>
                    </div>
                    <div class="content-section" v-if="!showContactForm" v-motion :initial="{
                        opacity: 0,
                        y: 100,
                    }" :enter="{
                        opacity: 1,
                        y: 0,
                    }">
                        <p class="description">
                           I’m a Full-Stack JavaScript Developer with {{ yearsOfExperience }}+ years of experience crafting dynamic, scalable, and impactful web applications. From intuitive frontends to powerful backends, I love building seamless digital experiences that make a difference.
                        </p>
                    </div>
                    <div class="buttons-section" v-if="!showContactForm">
                        <button class="call-btn" @click="toggleContactForm">Make a call</button>
                        <button class="download-btn" :disabled="loading" @click="downloadResume">
                            <p class="tooltip">Download CV</p>
                            <div class="download-icon-wrapper" v-if="!loading">
                                <svg class="svgIcon" viewBox="0 0 384 512" height="1em"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z">
                                    </path>
                                </svg>
                                <span class="icon2"></span>
                            </div>
                            <div v-else>
                                <v-progress-circular color="white" :width="2" :size="25"
                                    indeterminate></v-progress-circular>
                            </div>
                        </button>
                    </div>
                    <div class="contact-forms" v-else v-motion :initial="{
                        opacity: 0,
                        y: 100,
                    }" :visible="{
                        opacity: 1,
                        y: 0,
                    }">
                        <div class="forms">
                            <div class="form-row">
                                <div class="field-wrapper">
                                    <p class="label">This is</p>
                                    <input class="input-text" v-model="userName" type="text" placeholder="Your Name">
                                </div>
                                <div class="field-wrapper">
                                    <p class="label">Working In</p>
                                    <input class="input-text" type="text" v-model="workingIn"
                                        placeholder="Your company">
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="field-wrapper">
                                    <p class="label">Contact me at</p>
                                    <input class="input-text email" type="email" v-model="emailId"
                                        placeholder="Your email id">
                                </div>
                            </div>
                        </div>
                        <button @click="submitQuery" :disabled="sendingRequest" class="lets-work">Let's work
                            <v-progress-circular v-if="sendingRequest" color="black" :width="2" :size="25"
                                indeterminate></v-progress-circular>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="dummy-wrapper"></div>
        <v-snackbar v-model="showToaster" timeout='4000' color="#252626">
            <div class="toaster-card">
                <img :src="require('@/assets/icons/success-icon.svg')" v-if="toasterType == 'success'" />
                <img :src="require('@/assets/icons/error-icon.svg')" v-else />
                <p class="toaster-text">{{ toasterMsg }}</p>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'HomePage',
    data() {
        return {
            showContactForm: false,
            toasterType: '',
            backendUrl: process.env.VUE_APP_BACKEND_URL,
            showToaster: false,
            toasterMsg: '',
            dropdownOpen: false,
            selectedOption: '',
            needForOptions: [
                { value: 'jobOpportunity', text: 'Job Opportunity' },
                { value: 'collaboration', text: 'Collaboration' },
                { value: 'techSupport', text: 'Technical Support' },
                { value: 'general', text: 'General Inquiry' },
                { value: 'other', text: 'Other' },
            ],
            emailId: '',
            userName: '',
            workingIn: '',
            sendingRequest: false,
            loading: false,
            typedTitle: '',
            fullTitle: 'Behind the Code: My Story!',
            typingSpeed: 70,
            deletingSpeed: 40,
            pauseBeforeDelete: 1800,
            pauseBeforeType: 500
        };
    },
    components: {

    },
    computed: {
        selectedOptionText() {
            const selected = this.needForOptions.find(option => option.value === this.selectedOption);
            return selected ? selected.text : 'Select';
        },
        yearsOfExperience() {
            const careerStart = new Date(2021, 4, 1);
            const now = new Date();
            let years = now.getFullYear() - careerStart.getFullYear();
            const monthDiff = now.getMonth() - careerStart.getMonth();
            if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < careerStart.getDate())) {
                years--;
            }
            return years;
        }
    },
    mounted() {
        this.startTyping();
    },
    methods: {
        startTyping() {
            let index = 0;
            const typeNextChar = () => {
                index++;
                this.typedTitle = this.fullTitle.slice(0, index);
                if (index < this.fullTitle.length) {
                    setTimeout(typeNextChar, this.typingSpeed);
                } else {
                    setTimeout(deleteNextChar, this.pauseBeforeDelete);
                }
            };
            const deleteNextChar = () => {
                index--;
                this.typedTitle = this.fullTitle.slice(0, index);
                if (index > 0) {
                    setTimeout(deleteNextChar, this.deletingSpeed);
                } else {
                    setTimeout(typeNextChar, this.pauseBeforeType);
                }
            };
            typeNextChar();
        },
        toggleContactForm() {
            this.showContactForm = !this.showContactForm;
            if (this.showContactForm) {
                this.emailId = '';
                this.workingIn = '';
                this.userName = '';
            }
        },

        onSubmit() {
            this.showToaster = true;
            this.toggleContactForm();
        },

        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },
        selectOption(value) {
            this.selectedOption = value;
            this.dropdownOpen = false;
        },

        async downloadResume() {
            this.loading = true;
            axios.get(this.backendUrl + '/resume')
                .then(async (response) => {
                    const signedUrl = response.data.data.url;

                    // Create a temporary anchor element
                    const link = document.createElement('a');
                    link.href = signedUrl;
                    link.download = 'resume.pdf'; // Optional: specify the file name here

                    // Append to the body and trigger click
                    document.body.appendChild(link);
                    link.click();

                    // Clean up and remove the temporary element
                    document.body.removeChild(link);

                    this.toasterMsg = '🚀 Thanks for Downloading My CV! 🚀';
                    this.showToaster = true;
                    this.toasterType = 'success';
                    this.sendingRequest = false;
                    this.loading = false;
                })
                .catch(error => {
                    console.log('error', error)
                    this.toasterMsg = 'Oops! Something went wrong';
                    this.showToaster = true;
                    this.toasterType = 'error';
                    this.sendingRequest = false;
                    this.loading = false;
                });
        },

        validateFields() {
            if (this.userName.trim().length < 2 || this.workingIn.trim().length < 2) {
                return false;
            }
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(this.emailId.trim())) {
                return false;
            }
            return true;
        },

        async submitQuery() {
            this.sendingRequest = true;
            if (!this.validateFields()) {
                this.toasterMsg = 'All fields are required to get in touch!';
                this.showToaster = true;
                this.toasterType = 'error';
                this.sendingRequest = false;
                return;
            }

            let payload = {
                userName: this.userName.trim(),
                emailId: this.emailId.trim(),
                workingIn: this.workingIn.trim()
            };
            axios.post(this.backendUrl + '/queries', payload)
                .then(response => {
                    this.toasterMsg = 'You’re all set! We’ll be in touch soon.';
                    this.showToaster = true;
                    this.toasterType = 'success';
                    this.sendingRequest = false;
                    this.toggleContactForm();
                })
                .catch(error => {
                    this.toasterMsg = 'Oops! Something went wrong';
                    this.showToaster = true;
                    this.toasterType = 'error';
                    this.sendingRequest = false;
                });
        }
    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 32px 32px 0px 32px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    width: 100%;
    flex: 1;
    height: 100vh;
}



.wrapper {
    height: 100%;
}

.typing-demo {
    white-space: nowrap;
    overflow: hidden;
    display: inline-flex;
    align-items: center;
}

.cursor {
    display: inline-block;
    width: 3px;
    height: 1em;
    margin-left: 3px;
    background-color: currentColor;
    animation: blink .7s step-end infinite;
}

@keyframes blink {
    50% {
        opacity: 0;
    }
}

@keyframes jello-vertical {
    0% {
        transform: scale3d(1, 1, 1);
    }

    30% {
        transform: scale3d(0.75, 1.25, 1);
    }

    40% {
        transform: scale3d(1.25, 0.75, 1);
    }

    50% {
        transform: scale3d(0.85, 1.15, 1);
    }

    65% {
        transform: scale3d(1.05, 0.95, 1);
    }

    75% {
        transform: scale3d(0.95, 1.05, 1);
    }

    100% {
        transform: scale3d(1, 1, 1);
    }
}


.nav-wrapper {
    width: 100%;
    display: flex;
    gap: 24px;
    font-family: 'Sans';
    background-color: var(--primary-bg-color);
    align-items: center;
}

.top-container {
    display: flex;
    flex-direction: column;
    gap: 4rem;
}

.name-info-section {
    padding-left: 40px;
}

.no-break-text {
    word-break: keep-all;
    white-space: nowrap;
    font-family: 'PlayBall';
}

.skill-card img {
    width: 32px;
    height: 32px;
    animation: spin-icon 6s linear infinite;
}

@keyframes spin-icon {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

.skill-card {
    border-radius: 50%;
    border: 1px solid #252626;
    background: #0C0C0D;
    display: flex;
    padding: 0.9rem;
    align-items: center;
    transition: all 0.3s ease-in-out;
    position: absolute;
    animation: jello-vertical 1s both;
}

.skill-card.left {
    top: 25%;
    left: -10px;
}

.skill-card.right {
    top: 18%;
    right: -10px;
}

.image-wrapper img {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
}

.name {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color);
    font-family: 'PlayBall';
}

.name .first {
    font-family: 'PlayBall';
}

.hello-text {
    font-size: 42px;
    font-weight: 600;
    background: linear-gradient(125deg, #B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.main-container {
    display: flex;
    gap: 1rem;
    flex: 1;
    padding: 0 32px;
    z-index: 99;
}

.left-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10rem;
}

.center-section {
    flex: 0.75;
    padding: 0 16px;
    position: relative;
}

.center-background {
    background: #C6B296;
    width: 100%;
    height: 100%;
}

.right-section {
    flex: 1;
    display: flex;
    padding-left: 24px;
}

.left-cont {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    justify-content: center;
    width: 100%;
}

.dummy-wrapper {
    background: radial-gradient(50% 50% at 50% 50%, #3F1D6A 0%, #A83AFF 20.02%, #7E30CC 41.93%, rgba(135, 38, 181, 0.5) 74.15%, rgba(82, 7, 157, 0) 100%);
    width: 94%;
    height: 800px;
    position: absolute;
    top: 550px;
}

.right-cont {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
}

.title {
    font-size: 1.5rem;
    font-weight: bold;
}

.name-text {
    color: var(--primary-text-color);
    font-size: 2.5rem;
    line-height: 3.2rem;
}

.designation-text {
    color: var(--secondary-text-color);
    font-family: 'Poppins';
    font-size: 18px;
    line-height: 32px;
    font-weight: 400;
}

.logo-wrapper {
    display: flex;
    align-items: center;
    border-radius: 50%;
    background: #0C0C0D;
    border: 1px solid #252626;
    width: 72px;
    height: 72px;
    overflow: hidden;
    justify-content: flex-end;
}

.dot {
    color: #FFA84B;
}

.call-btn {
    position: relative;
    font-family: 'Poppins';
    font-size: 1rem;
    font-weight: bold;
    background: linear-gradient(134.15deg, #B66BE1 24.79%, #FF6267 44.2%, #FFA84B 69.43%);
    padding: 0.6rem 1rem;
    cursor: pointer;
    border: none;

    &:before {
        position: absolute;
        content: 'Make a call';
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: #fff;
        color: #0C0C0D;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(.6rem, .6rem);
        transition: transform .3s cubic-bezier(.34, 1.56, .64, 1);
    }

    &:hover:after,
    &:hover:before {
        transform: translate(0);
    }

}

.buttons-section {
    display: flex;
    gap: 32px;
    align-items: center;
    justify-content: left;
    flex-wrap: wrap;
}

.download-btn {
    background: transparent;
    border: none;
    padding: 0.6rem 1rem;
    color: var(--primary-text-color)
}

.profile-img {
    width: 300px;
    /* height: 300px; */
    object-fit: cover;
}


.input-text {
    border-radius: 500px;
    border: 2px solid #252626;
    background-color: #151616;
    padding: 12px;
    outline: none;
    box-shadow: 0px 0px 10px 0px #0000001A;
}

.contact-forms {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.textarea {
    border-radius: 20px;
}

.forms {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.field-wrapper {
    display: flex;
    gap: 12px;
    align-items: center;
}

.field-wrapper.comments {
    align-items: baseline;
}

.label {
    white-space: nowrap;
}

.form-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex: 1;
    flex-wrap: wrap;
}

.lets-work {
    padding: 10px 24px;
    border-radius: 500px;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: #000;
    background-color: #fff;
    border: 1px solid;
    color: #0C0C0D;
    width: fit-content;
}

.email {
    flex: 1;
}


.custom-select-wrapper {
    position: relative;
    width: fit-content;
}

.custom-select {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    border: 2px solid #252626;
    border-radius: 500px;
    background-color: #151616;
    cursor: pointer;
    width: 200px;
}

.arrow {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid #fff;
}

.options-wrapper {
    border-radius: 12px;
    overflow: hidden;
    background-color: #151616;
    border: 2px solid #252626;
    width: 250px;
}

.custom-option {
    padding: 12px;
    cursor: pointer;
    color: #fff;
}

.custom-option:hover,
.custom-option.selected {
    background-color: #252626;
}

.icon-wrapper {
    background: #0C0C0D;
    border: 1px solid #252626;
    border-radius: 50%;
    padding: 12px;
    display: flex;
    position: absolute;
}

.icon-wrapper img {
    width: 32px;
    height: 32px;
}

.icon-wrapper.top-left {
    top: -44px;
    left: 40px;
}

.icon-wrapper.center {
    top: 1px;
    right: -12px;
}

.icon-wrapper.bottom {
    bottom: -17px;
    right: 30px;
}

.download-btn {
    border: none;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition-duration: .3s;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.11);
}

.download-icon-wrapper {
    display: flex;
    flex-direction: column;
}

.svgIcon {
    fill: #fff;
}

.icon2 {
    width: 18px;
    height: 5px;
    border-bottom: 2px solid #fff;
    border-left: 2px solid #fff;
    border-right: 2px solid #fff;
}

.download-btn:hover {
    transition-duration: .3s;
}

.download-btn:hover .svgIcon {
    fill: rgb(255, 255, 255);
    animation: slide-in-top 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}


@keyframes slide-in-top {
    0% {
        transform: translateY(-10px);
        opacity: 0;
    }

    100% {
        transform: translateY(0px);
        opacity: 1;
    }
}

@media (max-width: 1100px) {
    .container {
        height: auto;
    }

    .main-container {
        padding: 0;
    }
}


@media (max-width: 900px) {

    .container {
        padding: 3.5rem;
    }

    .skill-card {
        display: none;
    }

    .main-container {
        flex-direction: column;
        padding: 0;
    }

    .image-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .image-wrapper img {
        position: relative;
        width: 380px;
        height: 480px;
        align-items: center;
        display: flex;
        align-items: center;
        justify-content: center;
        object-fit: contain;
    }

    .left-section {
        gap: 4rem;
    }

    .right-section,
    .left-section {
        padding-left: 0;
    }

    .dummy-wrapper {
        width: 90%;
        height: 198px;
        position: absolute;
        top: 625px;
    }

    .name-info-section {
        padding: 0;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 2rem;
    }

    .image-wrapper {
        background-color: #C6B296;
        justify-content: flex-end;
        display: flex;
        align-items: center;
        flex-direction: column;
        height: 500px;
    }

    .skill-card {
        display: block;
        z-index: 99;
        height: 64px;
        border: none;
    }

    .main-container {
        gap: 2rem;
    }

    .dummy-wrapper {
        display: none;
    }

    .logo-wrapper {
        width: 50px;
        height: 50px;
        overflow: hidden;
    }

    .logo-wrapper img {
        width: 40px;
        height: 40px;
    }

    .name {
        font-size: 1.6rem;
    }

    .title {
        font-size: 1rem;
    }

    .description {
        font-size: 0.9rem;
        line-height: 1.4rem;
    }

    .call-btn,
    .download-btn {
        font-size: 0.9rem;
    }

    .hello-text,
    .name-text {
        font-size: 1.7rem;
    }


}
</style>

<style>
.v-overlay__content {
    top: 10%;
    position: absolute;
    right: 1%;
    border-radius: 8px;
    min-width: auto;
    padding: 0 16px 0 12px;
}

.v-snack__content {
    padding: 0;
}
</style>